import React, { useState } from "react";
import { addRss } from "../../../../api/rss";
import MessageView from "../UploadComponents/MessageView";

export default () => {
  const onSumbitRss = async rss => {
    if (!rss) return;
    try {
      const param = {
        rss: { rss_url: rss },
      };
      await addRss(param);
      setDone(true);
    } catch (err) {
      console.log("err =>", err);
    }
  };
  const [rss, setRss] = useState("");
  const [done, setDone] = useState(false);

  return done ? (
    <MessageView message="YES! Your podcast was uploaded" />
  ) : (
    <div className="podcast-upload mb-5 p-4">
      <h1>Add a Podcast</h1>
      <small className="font-weight-bold">Podcast Feed URL:</small>
      <div className="d-flex justify-content-between">
        <input
          type="text"
          className="form-control w-75 pl-0"
          value={rss}
          placeholder="e.g. https://yourshowname.podomatic.com/rss2.xml"
          onChange={({ target: { value } }) => setRss(value)}
        />
        <button
          onClick={() => onSumbitRss(rss)}
          className="btn btn-sm btn-primary text-uppercase"
        >
          import podcast
        </button>
      </div>
      <div className="where-to-find d-flex align-items-center py-2">
        <small>Where to find this on:</small>
        <div className="d-flex">
          <span>
            <a
              href="https://www.podomatic.com/podcast"
              className="text-secondary px-2"
              target="_blank"
            >
              Podomatic
            </a>
            |
          </span>
          <span>
            <a
              href="https://www.buzzsprout.com"
              className="text-secondary px-2"
              target="_blank"
            >
              Buzzsprout
            </a>
            |
          </span>
          <span>
            <a
              href="https://www.podbean.com"
              className="text-secondary px-2"
              target="_blank"
            >
              PodBean
            </a>
            |
          </span>
          <span>
            <a
              href="https://transistor.fm"
              className="text-secondary px-2"
              target="_blank"
            >
              Transistor
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};
